// extracted by mini-css-extract-plugin
export default {"popup":"RulesPopup_popup__RmHG2","title":"RulesPopup_title__Wur3+","label":"RulesPopup_label__d0E2u"};